//
//
//
//
//
//
//
//
//
//

import { clearCacheApi } from '@/api/systemConfig';
export default {
  name: 'clearCache',
  methods: {
    handleClear: function handleClear() {
      var _this = this;
      clearCacheApi().then(function (response) {
        _this.$message.success('清除成功');
      });
    }
  }
};